export enum EventNames {
  LoggedIn = 'logged_in',
  LoggedOut = 'logged_out',
  SearchBarClicked = 'search_bar_clicked',
  Selected = 'selected',
  Viewed = 'viewed',
  ButtonClicked = 'button_clicked',
  MerchantDocumentNumberInputClicked = 'cnpj_clicked',
  MerchantDocumentNumberInputSettled = 'cnpj_setted',
  NameInputClicked = 'name_clicked',
  NameInputSettled = 'name_setted',
  NaturalPersonDocumentNumberInputClicked = 'cpf_clicked',
  NaturalPersonDocumentNumberInputSettled = 'cpf_setted',
  EmailInputClicked = 'email_clicked',
  EmailInputSettled = 'email_setted',
  WhatsappInputClicked = 'whatsapp_clicked',
  WhatsappInputSettled = 'whatsapp_setted',
  LinkSent = 'link_sent',
  LinkButtonClicked = 'link_button_clicked',
  ContinueClicked = 'continue_clicked',
  SendSuccess = 'send_success',
  ConsentCreditTermsClicked = 'consent_credit_terms_clicked',
  AssociationButtonClicked = 'association_button_clicked',
  AssociationConfirmationClicked = 'association_confirmation_clicked',
  AssociationAdded = 'association_added',
  DisassociationButtonClicked = 'disassociation_button_clicked',
  DisassociationConfirmationClicked = 'disassociation_confirmation_clicked',
  AssociationRemoved = 'association_removed',
  CreateOrderButtonClicked = 'create_order_button_clicked',
  InvalidCnpj = 'invalid_cnpj',
  AmountClicked = 'amount_clicked',
  AmountSettled = 'amount_setted',
  InvalidAmount = 'invalid_amount',
  LimitValidationButtonClicked = 'limit_validation_button_clicked',
  LimitValidated = 'limit_validated',
  SendPaymentLinkButtonClicked = 'send_payment_link_button_clicked',
  SendPaymentLinkSucceded = 'send_payment_link_succeded',
  SendPaymentLinkError = 'send_payment_link_error',
  SendPaymentLinkFieldChanged = 'send_payment_link_field_changed',
  SendPaymentLinkMaxDueDayClicked = 'send_payment_link_max_due_day_clicked',
  SendPaymentLinkMaxDueDaySettled = 'send_payment_link_max_due_day_setted',
  SendPaymentLinkExternalIdClicked = 'send_payment_link_external_id_clicked',
  SendPaymentLinkExternalIdSettled = 'send_payment_link_external_id_setted',
  SendPaymentLinkContactClicked = 'send_payment_link_contact_clicked',
  SendPaymentLinkContactSettled = 'send_payment_link_contact_setted',
  CopyPaymentLinkButtonClicked = 'copy_payment_link_button_clicked',
  ResendPaymentLinkButtonClicked = 'resend_payment_link_button_clicked',
  ResendPaymentLinkSucceded = 'resend_payment_link_succeded',
  HomePageViewed = 'homepage_viewed',
  ResendOptInButtonClicked = 'resend_opt_in_button_clicked',
  ResendOptInConfirmationClicked = 'resend_opt_in_confirmation_clicked',
  ResendOptInSucceded = 'resend_opt_in_succeded',
  SendKycButtonClicked = 'send_kyc_button_clicked',
  SendKycConfirmationClicked = 'send_kyc_confirmation_clicked',
  SendKycCopyButtonClicked = 'copy_kyc_button_clicked',
  SendKycSucceded = 'send_kyc_succeded',
  HelpNumberButtonClicked = 'help_number_button_clicked',
  ChangePhoneNumberButtonClicked = 'change_phone_number_button_clicked',
  ChangePhoneNumberConfirmationClicked = 'change_phone_number_confirmation_clicked',
  ChangePhoneNumberSucceded = 'change_phone_number_succeded',
  NotificationLinkClicked = 'notification_link_clicked',
  NotificationsViewed = 'notifications_viewed',
  NotificationClicked = 'notification_clicked',
  FirstSaleCardButtonClicked = 'first_sale_card_button_clicked',
  TotalAvailableCardButtonClicked = 'total_available_card_button_clicked',
  HighlightCardCarouselScrolled = 'highlight_card_carousel_scrolled',
  OptinSnackbarClicked = 'optin_snackbar_clicked',
  KycToggleSelected = 'kyc_toggle_selected',
  KycToggleUnselected = 'kyc_toggle_unselected',
  KycToggleLearnMoreButtonClicked = 'kyc_toggle_learn_more_button_clicked',
  KycToggleLearnMoreCloseButtonClicked = 'kyc_toggle_learn_more_close_button_clicked',
  AlreadyRegisteredAlertClicked = 'merchant_signup__cnpj_error',
  CardBoletosButtonClicked = 'card_boletos_button_clicked',
  UnicSelected = 'unic_selected',
  BoletoPdfViewed = 'boleto_pdf_viewed',
  BoletoSendPdfButtonClicked = 'boleto_send_pdf_button_clicked',
  BoletoPdfSent = 'boleto_pdf_sent',
  BoletoSendPdfError = 'boleto_send_pdf_error',
  BoletoSendPdfButtonCopyClicked = 'boleto_send_pdf_button_copy_clicked',
  BoletoLinkViewed = 'boleto_link_viewed',
  BoletoSendLinkButtonClicked = 'boleto_send_link_button_clicked',
  BoletoLinkSent = 'boleto_link_sent',
  BoletoSendLinkError = 'boleto_send_link_error',
  BoletoSendLinkButtonCopyClicked = 'boleto_send_link_button_copy_clicked',
  FaqButtonClicked = 'faq_button_clicked',
  ModalNotificationViewed = 'modal_notification_viewed',
  SendNotificationButtonClicked = 'send_notification_button_clicked',
  ModalNotificationNotificationSent = 'modal_notification_notification_sent',
  ModalNotificationBackButtonClicked = 'modal_notification_back_button_clicked',
  ModalCsatViewed = 'modal_csat_viewed',
  ModalCsatBackButtonClicked = 'modal_csat_back_button_clicked',
  ModalCsatSendButtonClicked = 'modal_csat_send_button_clicked',
  ModalCsatSent = 'modal_csat_sent',
  ShowMoreClicked = 'show_more_clicked',
  IncreaseLimitButtonClicked = 'increase_limit_button_clicked',
  ValidatePageBackButtonClicked = 'validate_page_back_button_clicked',
  InstallmentsPageBackButtonClicked = 'installments_page_back_button_clicked',
  InstallmentsPageContinueButtonClicked = 'installments_page_continue_button_clicked',
  ReviewPageCloseButtonClicked = 'review_page_close_button_clicked',
  ReviewPageBackButtonClicked = 'review_page_back_button_clicked',
  ConfirmSucceded = 'confirm_succeded',
  ConfirmError = 'confirm_error',
  OrderEditLinkClicked = 'order_edit_link_clicked',
  PaymentEditLinkClicked = 'payment_edit_link_clicked',
  TermsClicked = 'terms_clicked',
}

export enum EventNamesCreditAnalysis {
  ClientSearchSubmitted = 'client_search_submitted',

  SearchPageViewed = 'search_page_viewed',
  SearchFocused = 'search_focused',
  SearchFilled = 'search_filled',
  SearchSubmitted = 'search_submitted',

  RatingsPageRequested = 'ratings_page_requested',
  RatingsPageViewed = 'ratings_page_viewed',
  RatingsPageNotfound = 'ratings_page_notfound',
  RatingsPageProcessing = 'ratings_page_processing',
  RatingsBackButtonClicked = 'ratings_back_button_clicked',
  RatingsPdfExported = 'ratings_pdf_exported',

  RatingsIdentificationClicked = 'ratings_identification_clicked',

  RatingsCreditPolicyClicked = 'ratings_credit_policy_clicked',
  RatingsCreditPolicyNewOrderClicked = 'ratings_credit_policy_new_order_clicked',

  RatingsCreditAnalysisRatingClicked = 'ratings_credit_analysis_rating_clicked',
  RatingsCreditAnalysisScoreClicked = 'ratings_credit_analysis_score_clicked',
  RatingsCreditAnalysisRiskClicked = 'ratings_credit_analysis_risk_clicked',
  RatingsCreditAnalysisDefaultClicked = 'ratings_credit_analysis_default_clicked',
  RatingsCreditAnalysisPotentialLimitClicked = 'ratings_credit_analysis_potential_limit_clicked',

  RatingsPendencyClicked = 'ratings_pendency_clicked',
  RatingsPendencyProtestsDetailsModalOpened = 'ratings_pendency_protests_details_modal_opened',
  RatingsShareholdersModalOpened = 'ratings_shareholders_modal_opened',
  RatingsTrustedContactsModalOpened = 'ratings_trusted_contacts_modal_opened',
  RatingsLocationPhotosOpened = 'ratings_location_photos_opened',
  RatingsLocationMapsOpened = 'ratings_location_maps_opened',

  RatingsResumeCopyClicked = 'ratings_resume_copy_clicked',
  RatingsResumeUpVoteClicked = 'ratings_resume_up_vote_clicked',
  RatingsResumeDownVoteClicked = 'ratings_resume_down_vote_clicked',

  RatingsGeneralViewViewed = 'ratings_general_view_viewed',
  RatingsCommercialReferencesViewed = 'ratings_commercial_references_viewed',
  RatingsCommercialReferencesEmptyViewed = 'ratings_commercial_references_empty_viewed',
  RatingsPendenciesViewed = 'ratings_pendencies_viewed',

  RatingsSocialMediaRecommendationSubmitted = 'ratings_social_media_recommendation_submitted',
  RatingsSocialMediaNetworkClicked = 'ratings_social_media_network_clicked',
  RatingsSocialMediaUpVoteClicked = 'ratings_social_media_up_vote_clicked',
  RatingsSocialMediaDownVoteClicked = 'ratings_social_media_down_vote_clicked',
  RatingsSocialMediaInfoClicked = 'ratings_social_media_info_clicked',

  RequestOptInOpenModalButtonClicked = 'request_opt_in_open_modal_button_clicked',
  RequestOptInCloseModal = 'request_opt_in_close_modal',
  RequestOptInButtonClicked = 'request_opt_in_button_clicked',
  RequestOptInPhoneClicked = 'request_opt_in_phone_clicked',
  RequestOptInPhoneSetted = 'request_opt_in_phone_setted',
  RequestOptInSuccess = 'request_opt_in_success',
  RequestOptInError = 'request_opt_in_error',
  RequestPendingOptInCloseModal = 'request_pending_opt_in_close_modal',
  RequestPendingOptInCopiedLink = 'request_pending_opt_in_copied_link',
  RatingsChangesClicked = 'ratings_changes_clicked',

  RatingsFeedbackResponse = 'ratings_feedback_response',
}

export type EventNamesSupplier = EventNames | EventNamesCreditAnalysis
